export const dateChangeWeek = (date: Date, dir: 'back' | 'up') => {
  const newDate = new Date(date)
  if (dir === 'back') {
    newDate.setDate(newDate.getDate() - 7)
  } else {
    newDate.setDate(newDate.getDate() + 7)
  }
  return newDate
} 